export default __webpack_public_path__ + "static/ui-tasks-add-comment-df60e873baddeac6e0978271142d48ab.png";